<a
    class="pill pill--contact"
    *ngIf="employeeFetched"
    (click)="openEmployeeDetailModal(); $event.stopPropagation()">
    <img src="https://eu.ui-avatars.com/api/?background=random&bold=true&name={{ employeeFetched.firstName + ' ' + employeeFetched.lastName }}" />
    {{ employeeFetched.firstName + ' ' + employeeFetched.lastName }}
</a>
